import classNames from "classnames";
import { Link } from "react-router-dom";
import { ScaleLoader } from "react-spinners";

const black = "bg-gray-800";
const gray = "bg-gray-300";
const success = "bg-success";
const danger = "bg-danger";
const gold = "bg-yellow-400";
const white = "bg-white";
const indigo = "bg-indigo-600";

export const BtnColor = { black, gray, success, danger, gold, white, indigo };

const textBlack = "text-black";
const textWhite = "text-white";

const Button = ({
    color,
    className,
    onClick,
    children,
    type = "submit",
    disabled = false,
    isUpperCase = true,
    to,
    tracing = "tracking-widest",
    fontWeight = "font-semibold",
    isLoading = false
}) => {
    let currColor;
    let textColor;
    let hoverClass =
        "hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900";

    switch (color) {
        case BtnColor.white:
            {
                currColor = white;
                textColor = textBlack;
                hoverClass =
                    "border border-gray-300 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300";
            }
            break;
        case BtnColor.gold:
            {
                currColor = gold;
                textColor = textBlack;
                hoverClass =
                    "hover:bg-yellow-500 focus:outline-none focus:border-yellow-500";
            }
            break;
        case BtnColor.success:
            {
                currColor = success;
                textColor = textBlack;
            }
            break;
        case BtnColor.danger:
            {
                currColor = danger;
                textColor = textWhite;
                hoverClass =
                    "hover:bg-red-500 focus:outline-none focus:border-red-700";
            }
            break;
        case BtnColor.gray:
            {
                currColor = gray;
                textColor = textBlack;
                hoverClass =
                    "hover:bg-gray-400 focus:outline-none focus:bg-gray-400";
            }
            break;
        case BtnColor.indigo:
            {
                currColor = indigo;
                textColor = textWhite;
                hoverClass =
                    "hover:bg-gray-400 hover:bg-indigo-700 focus:outline-none ";
            }
            break;
        case BtnColor.black:
        default:
            {
                currColor = black;
                textColor = textWhite;
            }
            break;
    }

    const btnClass = classNames(
        ` items-center px-4 py-2  border border-transparent rounded-md text-sm ${
            isUpperCase ? "uppercase" : "normal-case"
        }  focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150`,
        className,
        currColor,
        textColor,
        hoverClass,
        {
            "pointer-events-none cursor-default": disabled,
            tracing,
            fontWeight,
        }
    );
    return (
        <>
            {type === "link" && to && !disabled ? (
                <Link to={to} className={btnClass}>
                    {children}
                </Link>
            ) : (
                <button
                    onClick={onClick}
                    type={type}
                    disabled={disabled}
                    className={btnClass}
                >
                    <div className="flex">
                        {!!isLoading && (
                            <div className="mr-2">
                                <ScaleLoader height={10} color="#7A5AF8" />
                            </div>
                        )}
                        <span>{children}</span>
                    </div>
                </button>
            )}
        </>
    );
};

export default Button;
